var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoDirections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 22V16L7.9 14L6.9 18.4L0 17L0.4 15L5.2 16L6.8 7.9L5 8.6V12H3V7.3L6.95 5.6C7.53333 5.35 7.9625 5.1875 8.2375 5.1125C8.5125 5.0375 8.76667 5 9 5C9.35 5 9.675 5.09167 9.975 5.275C10.275 5.45833 10.5167 5.7 10.7 6L11.7 7.6C12.1333 8.3 12.7208 8.875 13.4625 9.325C14.2042 9.775 15.05 10 16 10V12C14.9 12 13.8708 11.7708 12.9125 11.3125C11.9542 10.8542 11.15 10.25 10.5 9.5L9.9 12.5L12 14.5V22H10ZM10.5 4.5C9.95 4.5 9.47917 4.30417 9.0875 3.9125C8.69583 3.52083 8.5 3.05 8.5 2.5C8.5 1.95 8.69583 1.47917 9.0875 1.0875C9.47917 0.695833 9.95 0.5 10.5 0.5C11.05 0.5 11.5208 0.695833 11.9125 1.0875C12.3042 1.47917 12.5 1.95 12.5 2.5C12.5 3.05 12.3042 3.52083 11.9125 3.9125C11.5208 4.30417 11.05 4.5 10.5 4.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDirections);
export default __webpack_public_path__ + "static/media/info_directions.f1ddef47bf749f29323cd713d1acc6aa.svg";
export { ForwardRef as ReactComponent };